export const GET_CMS_SUCURSALES = "GET_CMS_SUCURSALES";
export const GET_CMS_CONVENIOS = "GET_CMS_CONVENIOS";
export const CALCULAR_CREDITO = "CALCULAR_CREDITO";
export const CALCULAR_CREDITO_ERROR = "CALCULAR_CREDITO_ERROR";
export const GET_ALL_CREDITOS = "GET_ALL_CREDITOS";
export const GET_ALL_CREDITOS_ERROR = "GET_ALL_CREDITOS_ERROR";
export const GET_CMS_INFO_CREDITOS_PERSONALES =
  "GET_CMS_INFO_CREDITOS_PERSONALES";
export const GET_CMS_INFO_CREDITOS_HIPOTECARIOS =
  "GET_CMS_INFO_CREDITOS_HIPOTECARIOS";
export const GET_CMS_INFO_CREDITOS_PRODUCTIVOS =
  "GET_CMS_INFO_CREDITOS_PRODUCTIVOS";
export const GET_CMS_INFO_AHORROS_PROGRAMADOS =
  "GET_CMS_INFO_AHORROS_PROGRAMADOS";
export const GET_ALL_SERVIAHORRO = "GET_ALL_SERVIAHORRO";
export const GET_ALL_SERVIAHORRO_ERROR = "GET_ALL_SERVIAHORRO_ERROR";
export const GET_CMS_INVERSIONES = "GET_CMS_INVERSIONES";
export const GET_CMS_HISTORIA = "GET_CMS_HISTORIA";
export const GET_CMS_HISTORIA_ERROR = "GET_CMS_HISTORIA_ERROR";
export const GET_CMS_DELEGADOS = "GET_CMS_DELEGADOS";
export const GET_CMS_PLANES_ASISTENCIA = "GET_CMS_PLANES_ASISTENCIA";
export const GET_CMS_PLANES_ASISTENCIA_ERROR =
  "GET_CMS_PLANES_ASISTENCIA_ERROR";
export const GET_CMS_TARJETAS = "GET_CMS_TARJETAS";
export const GET_CMS_TARJETAS_ERROR = "GET_CMS_TARJETAS_ERROR";
export const GET_CMS_BIENES_BANNER = "GET_CMS_BIENES_BANNER";
export const GET_CMS_BIENES_BANNER_ERROR = "GET_CMS_BIENES_BANNER_ERROR";
export const GET_CMS_AFILIACION = "GET_CMS_AFILIACION";
export const GET_CMS_ORGANIZACION = "GET_CMS_ORGANIZACION";
export const GET_CMS_ORGANIZACION_ERROR = "GET_CMS_ORGANIZACION_ERROR";
export const GET_CMS_TIPS_SEGURIDAD = "GET_CMS_TIPS_SEGURIDAD";
export const GET_CMS_TIPS_SEGURIDAD_ERROR = "GET_CMS_TIPS_SEGURIDAD_ERROR";
export const GET_CMS_FIRMA_DIGITAL = "GET_CMS_FIRMA_DIGITAL";
export const GET_CMS_FIRMA_DIGITAL_ERROR = "GET_CMS_FIRMA_DIGITAL_ERROR";
export const GET_CMS_REGLAMENTOS = "GET_CMS_REGLAMENTOS";
export const GET_CMS_REGLAMENTOS_ERROR = "GET_CMS_REGLAMENTOS_ERROR";
export const GET_CMS_PROMOCIONES = "GET_CMS_PROMOCIONES";
export const GET_CMS_PROMOCIONES_ERROR = "GET_CMS_PROMOCIONES_ERROR";
export const GET_CMS_RESUME_BANNER = "GET_CMS_RESUME_BANNER";
export const GET_CMS_RESUME_BANNER_ERROR = "GET_CMS_RESUME_BANNER_ERROR";
export const GET_CMS_COMUNICADOS = "GET_CMS_COMUNICADOS"
export const GET_CMS_COMUNICADOS_ERROR = "GET_CMS_COMUNICADOS_ERROR"
export const GET_CMS_GESTION_PAGOS = "GET_CMS_GESTION_PAGOS"
export const GET_CMS_GESTION_PAGOS_ERROR = "GET_CMS_GESTION_PAGOS_ERROR"
